import { render } from "./ChoiseShop.vue?vue&type=template&id=0ef62c6d&scoped=true"
import script from "./ChoiseShop.vue?vue&type=script&lang=js"
export * from "./ChoiseShop.vue?vue&type=script&lang=js"

import "./ChoiseShop.vue?vue&type=style&index=0&id=0ef62c6d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef62c6d"]])

export default __exports__